import { useResizingHeight } from "@atlaskit/motion";
import { breakpointSizes, Button, Size } from "@brightagency/headstart-common";
import React, { useCallback, useEffect, useState } from "react";
import { WPPost } from "../../../constants/types";
import { useBreakpoint } from "../../../controllers";
import { getWpPostUrl } from "../../../utils";
import { ConditionCard } from "../../molecules/ConditionCard";
import { Grid } from "../../molecules/Grid";
import { CarouselSection } from "../CarouselSection";

const gridBreakpoints = [
    { breakpointWidth: breakpointSizes.xsmall, columns: 1, gutter: 10 },
    { breakpointWidth: breakpointSizes.medium, columns: 3, gutter: 16 },
    { breakpointWidth: breakpointSizes.large, columns: 4, gutter: 16 },
];

interface Props {
    id: string;
    title: string;
    conditions: WPPost[];
}

export const ConditionList: React.FC<Props> = props => {
    const isMedium = useBreakpoint(Size.medium);
    const isLarge = useBreakpoint(Size.large);
    const [isExpanded, setIsExpanded] = useState(false);
    const [showItemsNumber, setShowItemsNumber] = useState(4);
    const resizingHeightProps = useResizingHeight();

    useEffect(() => {
        if (isLarge) {
            setShowItemsNumber(7);
        } else if (isMedium) {
            setShowItemsNumber(5);
        } else {
            setShowItemsNumber(4);
        }
    }, [isMedium, isLarge]);


    const renderCard = useCallback((condition: WPPost) => {
        return (
            <ConditionCard
                key={condition.id}
                title={condition.title.rendered}
                to={getWpPostUrl(condition)}
            />
        );
    }, []);

    return (
        <CarouselSection id={props.id} title={props.title}>
            <div {...resizingHeightProps}>
                <Grid breakpoints={gridBreakpoints}>
                    {isExpanded
                        ? props.conditions.map(renderCard)
                        : props.conditions.slice(0, showItemsNumber).map(renderCard)}
                    <Button
                        style={{ width:"100%", height:"65px" }}
                        size="large"
                        shape="rounded"
                        onClick={(event: MouseEvent) => {
                            if (event.target instanceof HTMLButtonElement) {
                                event.target.blur();
                            }
                            setIsExpanded(a => !a);
                        }}
                    >
                        {isExpanded ? "View less" : "View all"}
                    </Button>
                </Grid>
            </div>
        </CarouselSection>
    );
};
